module.exports = __webpack_public_path__ + "assets/db11c68cc2a5571382b1ad983b8c99ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/bg2.png
// module id = 379
// module chunks = 1